import type { TruyVanThongKeAi } from '../nghiep-vu/types-thong-ke';

const GOC = ['nktv'] as const;

/**
 * Khoá truy vấn của Nhật ký sử dụng AI. Hook vết (`su-dung-ai/hooks.ts`) đặt khoá dưới cùng gốc `nktv` để một lượt
 * `invalidateQueries({ queryKey: nktvKeys.all })` làm mới được cả nhóm. `nguon` là tiền tố của `NguonVet`.
 */
export const nktvKeys = {
  all: GOC,
  thongKeAi: (nguon: readonly unknown[], thamSo: TruyVanThongKeAi) => [...GOC, ...nguon, 'thong-ke-ai', thamSo] as const,
};
